module.exports = __webpack_public_path__ + "static/media/login.bad19771.svg";